import { useCallback, useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet-async';
// @mui
import {
    Card,
    Container,
    IconButton,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    Typography,
} from '@mui/material';
// components
import Iconify from '../components/iconify';
// sections
// mock
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import ButtonAction from 'src/components/Button.js/SaveButton';
import DepartmentListHead from 'src/sections/@dashboard/department/DepartmentListHead';
import { glb_sv, sendRequest, serviceList } from 'src/utils';

import moment from 'moment';
import { useParams } from 'react-router-dom';
import Breadcrumb from 'src/components/Breadcrumb/Breadcrumb';
import DrawerSidebar from 'src/components/DrawerSidebar/DrawerSidebar';
import EmtyData from 'src/components/emty-data';
import Label from 'src/components/label/Label';
import Loader from 'src/components/loader/loader';

// ----------------------------------------------------------------------

export default function GiveDeive() {
    const [openSibarDevice, setopenSibarDevice] = useState(false);

    const dataActionRef = useRef(null);

    const { t } = useTranslation();
    const getRef = useRef(false);
    const [getFlags, setGetFlags] = useState(false);
    const [tableData, setTableData] = useState([]);

    const [dataAction, setDataAction] = useState({});

    const path = window.location.pathname;
    const tableRef = useRef(null);
    const userAccount = glb_sv.userInfo;
    const isAdmin = userAccount?.group_user === '1';

    const TABLE_HEAD = [
        { id: 'name', label: t('device'), alignRight: false },
        { id: 'company', label: t('info'), alignRight: false },
        { id: 'quantity_give', label: t('quantity_give'), alignRight: false },
        { id: 'note', label: t('note_'), alignRight: false },
        { id: 'quantity_give', label: t('day_need_give'), alignRight: false },
        { id: 'quantity_borrow', label: t('quantity_borrow'), alignRight: false },
    ];

    if (isAdmin) {
        TABLE_HEAD.push({ id: 'note', label: t('name_staff'), alignRight: false });
    }

    TABLE_HEAD.push([
        { id: 'Thao tác', label: '', alignRight: false },
        { id: '1', label: '', alignRight: false },
        { id: '2', label: '', alignRight: false },
    ]);

    useEffect(() => {
        setTimeout(() => {
            getData();
        }, 1000);
    }, []);

    const getData = useCallback(() => {
        if (getRef.current) {
            return;
        }
        getRef.current = true;
        setGetFlags(true);
        const InVal = ['', ''];
        sendRequest(serviceList.getGiveTransaction, InVal, getDataResult, true, timeOutFunct, 40000);
    }, []);

    const getDataResult = (reqInfoMap, message) => {
        getRef.current = false;
        setGetFlags(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            let data = message.proc_data.rows[0].o_1;
            data = data.filter((item) => (item.qty_tra = item.qty - item.qty_change_request));
            setTableData(data);
            // console.log(data);
        }
    };

    const timeOutFunct = (reqInfo) => {
        getRef.current = false;
        setGetFlags(false);
        toast.error(t('error.time_out'));
    };
    // delete device category online

    const addQuantity = (data, index, key, maxnumber = 1) => {
        if (key) {
            if (index >= 0 && data.qty_tra < data.qty - data.qty_change_request) {
                const arr = [...tableData];
                arr[index].qty_tra = arr[index].qty_tra + 1;
                setTableData(arr);
            }
        } else {
            if (data.qty_tra > 1) {
                const arr = [...tableData];
                arr[index].qty_tra = arr[index].qty_tra - 1;
                setTableData(arr);
            }
        }
    };

    return (
        <>
            <Helmet>
                <title> {t('give_device')} </title>
            </Helmet>

            <Container>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                    <Typography variant="h4" gutterBottom>
                        {t('give_device')}
                    </Typography>
                </Stack>
                <Breadcrumb
                    paths={[
                        // {
                        //     label: t('group_devices'),
                        //     url: `/home/group/${path?.split('/')[3]}/${params.idPermission}`,
                        //     navigate: false,
                        // },
                        { label: t('give_device'), url: '#', navigate: false },
                    ]}
                />
                <Loader loading={getFlags} />
                <DrawerSidebar
                    open={openSibarDevice}
                    onClose={() => setopenSibarDevice(false)}
                    onOpen={() => setopenSibarDevice(true)}
                    setOpen={setopenSibarDevice}
                    device={dataAction}
                    isGivedevice
                    getData={getData}
                />

                <Card>
                    {' '}
                    {/* <Grid padding={'20px 10px'} container spacing={2} style={{}}>
                        <Grid item xl={6} md={6} sm={12} style={{ width: '100%' }}>
                            <DatePickerValue label={t('start_day')} valueChange={startDay} getValue={setstartDay} />
                        </Grid>
                        <Grid item xl={6} md={6} sm={12} style={{ width: '100%' }}>
                            <DatePickerValue label={t('to_day')} valueChange={toDay} getValue={settoDay} />
                        </Grid>
                    </Grid> */}
                    <Loader loading={getFlags} />
                    <TableContainer sx={{}}>
                        <Table ref={tableRef}>
                            <DepartmentListHead
                                order={'asc'}
                                orderBy={'name'}
                                headLabel={TABLE_HEAD}
                                rowCount={tableData.length}
                                // numSelected={selected.length}
                            />
                            <TableBody>
                                {tableData.length > 0 &&
                                    tableData.map((item, index) => {
                                        if (['ebr', 'cdr', 'rde'].includes(item.bussiness))
                                            return (
                                                <TableRow
                                                    hover
                                                    key={index}
                                                    tabIndex={-1}
                                                    role="checkbox"
                                                    // selected={selectedUser}
                                                >
                                                    <TableCell padding="checkbox"></TableCell>
                                                    <TableCell
                                                        align="left"
                                                        style={{ width: '100%', minWidth: '250px' }}
                                                    >
                                                        <Stack direction="row" alignItems="center" spacing={2}>
                                                            <img
                                                                style={{
                                                                    width: '80px',
                                                                    height: '80px',
                                                                    borderRadius: '5px',
                                                                    backgroundColor: '#999',
                                                                }}
                                                                // src={`${glb_sv.urlGetProductImage(item.pic_device)}`}
                                                                src={
                                                                    item?.img_device
                                                                        ? `${glb_sv.urlGetProductImage(
                                                                              item?.img_device
                                                                          )}`
                                                                        : `${glb_sv.urlGetProductImage(
                                                                              item?.pic_device
                                                                          )}`
                                                                }
                                                                alt=""
                                                            />
                                                            <Typography variant="subtitle2">
                                                                {glb_sv.convertMultipleLanguages(item.device_nm)}
                                                            </Typography>
                                                        </Stack>
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        <Stack display={'flex'} flexDirection={'column'}>
                                                            <Typography
                                                                variant="subtitle3"
                                                                noWrap
                                                                sx={{ fontWeight: '600' }}
                                                            >
                                                                {t('cabinet')}: {item.cabinet_nm}
                                                            </Typography>
                                                            <Typography variant="subtitle3" noWrap>
                                                                {t('drawer')}: {item.drawer_nm}
                                                            </Typography>{' '}
                                                            <Typography variant="subtitle3" noWrap>
                                                                {t('cell')}:{' '}
                                                                {`[ ${item?.cell_lc?.row} : ${item?.cell_lc?.column} ]`}
                                                            </Typography>
                                                        </Stack>
                                                    </TableCell>
                                                    <TableCell style={{ textAlign: 'center' }}>{item?.qty}</TableCell>{' '}
                                                    <TableCell style={{ textAlign: 'center' }}>{item?.note}</TableCell>{' '}
                                                    <TableCell style={{ textAlign: 'center' }}>
                                                        {' '}
                                                        <Label
                                                            color={
                                                                (moment(item.expiry_date, 'YYYYMMDD').diff(
                                                                    moment(),
                                                                    'days'
                                                                ) <= 2 &&
                                                                    'error') ||
                                                                'primary'
                                                            }
                                                        >
                                                            {moment(item?.return_date, 'YYYYMMDD').format('DD/MM/YYYY')}{' '}
                                                        </Label>
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        <Stack
                                                            display={'flex'}
                                                            flexDirection={'row'}
                                                            gap={0.5}
                                                            border={'1px solid #999'}
                                                            borderRadius={'3px'}
                                                            justifyContent={'center'}
                                                            alignItems={'center'}
                                                        >
                                                            <IconButton
                                                                color={'primary'}
                                                                onClick={() => addQuantity(item, index)}
                                                            >
                                                                <Iconify
                                                                    icon="material-symbols:check-indeterminate-small"
                                                                    width={16}
                                                                    height={16}
                                                                />
                                                            </IconButton>
                                                            <Typography
                                                                variant="subtitle3"
                                                                noWrap
                                                                sx={{
                                                                    fontWeight: '600',
                                                                }}
                                                            >
                                                                {item.qty_tra}
                                                            </Typography>
                                                            <IconButton
                                                                color={'primary'}
                                                                onClick={() => addQuantity(item, index, 1, item.qty)}
                                                            >
                                                                <Iconify
                                                                    icon="material-symbols:add"
                                                                    width={16}
                                                                    height={16}
                                                                />
                                                            </IconButton>
                                                        </Stack>
                                                    </TableCell>
                                                    {isAdmin && (
                                                        <TableCell
                                                            align="right"
                                                            style={{ textAlign: 'center', maxWidth: '120px' }}
                                                        >
                                                            <Stack sx={{ gap: 1 }}>{item?.user_nm}</Stack>
                                                        </TableCell>
                                                    )}
                                                    {(item?.user_id === userAccount?.id || isAdmin) && (
                                                        <TableCell
                                                            align="right"
                                                            style={{ textAlign: 'center', maxWidth: '120px' }}
                                                        >
                                                            <Stack sx={{ gap: 1 }}>
                                                                <ButtonAction
                                                                    type="confirm"
                                                                    title={t('give')}
                                                                    onClick={() => {
                                                                        dataActionRef.current = item;
                                                                        setDataAction(item);
                                                                        setopenSibarDevice(true);
                                                                    }}
                                                                />
                                                            </Stack>
                                                        </TableCell>
                                                    )}
                                                    <TableCell padding="checkbox"></TableCell>
                                                    <TableCell padding="checkbox"></TableCell>
                                                </TableRow>
                                            );
                                    })}
                            </TableBody>
                        </Table>
                        {tableData.length === 0 && <EmtyData />}
                    </TableContainer>
                </Card>
            </Container>
        </>
    );
}
